import { NameField } from '@src/entities/Criteria/ui/components/fields/Name';
import { User } from '@src/entities/User/ui/components/User';
import { Button as ButtonComponent } from '@src/shared/ui/components/Button';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import React, { useState } from 'react';

/**
 * Button: EditName
 *
 * This button is used to edit the name of the entity.
 *
 * @param currentEntity
 * @param form
 * @param refetch
 * @returns {Element}
 * @constructor
 */
export function Button({ currentEntity = {}, form = {}, refetch = () => {} }) {
  const [isOpen, setIsOpen] = useState(null);

  return (
    <ErrorHandler location="src/features/CommonCriteria/Edit/components/Button/Button.jsx">
      <Popover
        align="start"
        alignOffset={24}
        content={<NameField currentEntity={currentEntity} form={form} refetch={refetch} />}
        css={{ '.abyss-popover-content-container': { overflow: 'visible !important' } }}
        onOpenChange={() => {
          return isOpen === currentEntity?.id ? setIsOpen(null) : setIsOpen(currentEntity?.id);
        }}
        open={isOpen === currentEntity?.id}
        position="top"
        title=""
        width="auto"
      >
        <User.Capability attributes={['edit']} resource="Admin:CommonCriteria">
          <ButtonComponent
            onClick={() => {
              return setIsOpen(currentEntity?.id);
            }}
            variant="outline"
          >
            Edit Name
          </ButtonComponent>
        </User.Capability>
      </Popover>
    </ErrorHandler>
  );
}
